'use strict';

var _ = require('lodash');
var PubSub = require('tscom-pubsub');
var template = require('../templates/vote-option.ejs');

var VoteOptionView = require('standard-vote/app/scripts/views/vote-option');

module.exports = VoteOptionView.extend({

    render: function () {
        var model = this.model.toJSON();

        var isEliminated = _.checkIfTrue(model.eliminated);

        // check length of vote option name and slice it
        var fullName = model.firstname + ' ' + model.lastname;
        if(fullName.length >= 74) fullName = fullName.slice(0,73);
        model.fullname = fullName;

        var text = this.cms.get('text')['views_nominee_grid'];

        this.$el.html(template({
            model: model,
            text: text,
            isEliminated: isEliminated
        }));

        return this;
    },

    selectContestant: function (e) {
        e.preventDefault();
        this.voteOption.setSelected(this.model.get('id'));

        var evt = {
            event: 'button_click',
            action: 'select_contestant',
            contestant: this.model.get('id')
        };

        PubSub.trigger('trackGoogle',evt);
    }

});



// WEBPACK FOOTER //
// ./app/scripts/views/vote-option.js